import React from 'react';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FILE_ADD } from '../../actions/types';
import { hasAccess } from '../../utils';
import ButtonUpload from '../../components/ButtonUpload';
import FileUploader from '../../components/FileUploader';
import {
  ErrorField,
} from '../../lib/HooksFormFields';
import styles from './case.module.scss';

const FolderCase = ({
  currentFolder,
  selectedCase,
  file,
  selectedFiles,
  errorFile,
  isLoadingFile,
  handleChangeFile,
  handleDownload,
  handleSend,
  renderDocument,
}) => {
  const { authReducer } = useSelector((store) => store);
  const { user } = authReducer;

  function getBreadcrumbTrail(folder) {
    const links = [<NavLink key={`root-${folder._id}`} to={`/case/${selectedCase._id}`}>...</NavLink>, ' / '];
    const minSlice = folder.parents.length - 4 || 0;
    folder.parents.slice(minSlice, folder.parents.length).forEach((f, i) => {
      links.push(
        <NavLink key={`folder-${f._id}`} to={`/case/${selectedCase._id}?folder=${f._id}`}>
          {f.name || '...'}
        </NavLink>,
      );
      if (i < folder.parents.length) links.push(' / ');
    });
    return links;
  }

  return (
    <>
      <div className={styles.breadcrumbTrail}>
        <p>
          {getBreadcrumbTrail(currentFolder)}
          <span> {currentFolder.name}</span></p>
      </div>
      <div className={styles.files}>
        <div className={styles.header}>
          <h3>Documents</h3>
          <div className={styles.containerButtons}>
            {selectedFiles.length > 0 && (
              <>
                <button
                  className={`third ${styles.btnSend}`}
                  onClick={() => handleDownload()}
                >
                  Télécharger la selection
                </button>
                <button
                  className={`third ${styles.btnSend}`}
                  onClick={() => handleSend()}
                >
                  Envoyer par email
                </button>
              </>
            )}
            {hasAccess(user.role) && (
              <ButtonUpload
                isLoading={isLoadingFile.includes(FILE_ADD)}
                handleChangeFile={handleChangeFile}
              />
            )}
          </div>
        </div>
        {errorFile && (
          <div className={styles.errorMessage}>
            <ErrorField message={errorFile} />
          </div>
        )}
        {currentFolder.files.length
          ? renderDocument(currentFolder.files)
          : <div className={file ? `${styles.containerInputField} ${styles.disabled}` : styles.containerInputField}>
            {hasAccess(user.role) && (
              <FileUploader
                handleChangeFile={file ? () => { } : handleChangeFile}
                isLoading={isLoadingFile.includes(FILE_ADD)}
                file={file}
              />
            )}
          </div>
        }
      </div>
    </>
  );
};

export default FolderCase;
